export const LOW_ON_STOCK_LEVEL = 0.2;
export const INVENTORY_TABLE_ROWS_PER_PAGE = 10;
export const DEMO_INVENTORY_CREDITS_AMOUNT = 120000;
export const DEFAULT_INVENTORY_NAME = 'My inventory';
export const DEFAULT_INVENTORY_OPTION = {
  value: undefined,
  key: DEFAULT_INVENTORY_NAME,
  label: DEFAULT_INVENTORY_NAME
};
export const DEFAULT_ORDER_DISTRIBUTE_TYPE = 'Select an option *';
export const DEFAULT_ORDER_DISTRIBUTE_OPTION = {
  value: undefined,
  key: DEFAULT_ORDER_DISTRIBUTE_TYPE,
  label: DEFAULT_ORDER_DISTRIBUTE_TYPE
};
export let INVENTORY_PERMISSION_LEVELS = /*#__PURE__*/function (INVENTORY_PERMISSION_LEVELS) {
  INVENTORY_PERMISSION_LEVELS["PUSH"] = "PUSH";
  INVENTORY_PERMISSION_LEVELS["PULL"] = "PULL";
  INVENTORY_PERMISSION_LEVELS["PUSH_AND_PULL"] = "PUSH_AND_PULL";
  INVENTORY_PERMISSION_LEVELS["ADMIN"] = "ADMIN";
  INVENTORY_PERMISSION_LEVELS["OWNER"] = "OWNER";
  INVENTORY_PERMISSION_LEVELS["NO_ACCESS"] = "NO_ACCESS";
  return INVENTORY_PERMISSION_LEVELS;
}({});
export let INVENTORY_PERMISSION_NAMES = /*#__PURE__*/function (INVENTORY_PERMISSION_NAMES) {
  INVENTORY_PERMISSION_NAMES["PUSH"] = "Can add";
  INVENTORY_PERMISSION_NAMES["PULL"] = "Can distribute";
  INVENTORY_PERMISSION_NAMES["PUSH_AND_PULL"] = "Can add & distribute";
  INVENTORY_PERMISSION_NAMES["ADMIN"] = "Admin";
  INVENTORY_PERMISSION_NAMES["OWNER"] = "Owner";
  INVENTORY_PERMISSION_NAMES["NO_ACCESS"] = "No access";
  return INVENTORY_PERMISSION_NAMES;
}({});
export let GiveawayChangeStatusTriggers = /*#__PURE__*/function (GiveawayChangeStatusTriggers) {
  GiveawayChangeStatusTriggers["SMA"] = "sma";
  GiveawayChangeStatusTriggers["SOA"] = "soa";
  GiveawayChangeStatusTriggers["TRANSFER"] = "transfer";
  GiveawayChangeStatusTriggers["GIVEAWAY"] = "giveaway";
  GiveawayChangeStatusTriggers["CHANGE_MODE"] = "changeMode";
  return GiveawayChangeStatusTriggers;
}({});
export const APPROVE_ALL = 'all';
export const INVENTORY_PERMISSION_DESCRIPTION = {
  [INVENTORY_PERMISSION_LEVELS.ADMIN]: "You've been made an admin. Now you have full control over the inventory",
  [INVENTORY_PERMISSION_LEVELS.PUSH_AND_PULL]: "You're now able to add and distribute products.",
  [INVENTORY_PERMISSION_LEVELS.PUSH]: "You're now able to only add products to the inventory",
  [INVENTORY_PERMISSION_LEVELS.PULL]: "You're now able to only distribute products from the inventory"
};
export let INVENTORY_HISTORY_TYPES = /*#__PURE__*/function (INVENTORY_HISTORY_TYPES) {
  INVENTORY_HISTORY_TYPES["RENAME_INVENTORY"] = "RENAME_INVENTORY";
  INVENTORY_HISTORY_TYPES["STORAGE_FEE_PAID"] = "STORAGE_FEE_PAID";
  INVENTORY_HISTORY_TYPES["STORAGE_FEE_AUTOPAY_TOGGLE"] = "STORAGE_FEE_AUTOPAY_TOGGLE";
  INVENTORY_HISTORY_TYPES["STORAGE_FEE_AUTOPAY_SUCCESS"] = "STORAGE_FEE_AUTOPAY_SUCCESS";
  INVENTORY_HISTORY_TYPES["STORAGE_FEE_AUTOPAY_FAILED"] = "STORAGE_FEE_AUTOPAY_FAILED";
  INVENTORY_HISTORY_TYPES["STORAGE_FEE_INVOICE_SUCCESS"] = "STORAGE_FEE_INVOICE_SUCCESS";
  INVENTORY_HISTORY_TYPES["ADD_MEMBER"] = "ADD_MEMBER";
  INVENTORY_HISTORY_TYPES["CHANGE_PERMISSIONS"] = "CHANGE_PERMISSIONS";
  INVENTORY_HISTORY_TYPES["REMOVE_MEMBER"] = "REMOVE_MEMBER";
  INVENTORY_HISTORY_TYPES["ADD_PRODUCTS"] = "ADD_PRODUCTS";
  INVENTORY_HISTORY_TYPES["ORDER_MORE"] = "ORDER_MORE";
  INVENTORY_HISTORY_TYPES["REMOVE_PRODUCTS"] = "REMOVE_PRODUCTS";
  INVENTORY_HISTORY_TYPES["TRANSFER_PRODUCTS_TO"] = "TRANSFER_PRODUCTS_TO";
  INVENTORY_HISTORY_TYPES["TRANSFER_PRODUCTS_FROM"] = "TRANSFER_PRODUCTS_FROM";
  INVENTORY_HISTORY_TYPES["SHIPOUT_PRODUCTS"] = "SHIPOUT_PRODUCTS";
  INVENTORY_HISTORY_TYPES["CREATE_GIVEAWAY"] = "CREATE_GIVEAWAY";
  INVENTORY_HISTORY_TYPES["UPDATE_GIVEAWAY"] = "UPDATE_GIVEAWAY";
  INVENTORY_HISTORY_TYPES["END_GIVEAWAY"] = "END_GIVEAWAY";
  INVENTORY_HISTORY_TYPES["PAY_GIVEAWAY"] = "PAY_GIVEAWAY";
  INVENTORY_HISTORY_TYPES["DELETE_GIVEAWAY"] = "DELETE_GIVEAWAY";
  INVENTORY_HISTORY_TYPES["CREATE_CARD"] = "CREATE_CARD";
  INVENTORY_HISTORY_TYPES["UPDATE_CARD"] = "UPDATE_CARD";
  INVENTORY_HISTORY_TYPES["DELETE_CARD"] = "DELETE_CARD";
  INVENTORY_HISTORY_TYPES["USER_DEFAULT"] = "USER_DEFAULT";
  INVENTORY_HISTORY_TYPES["INVENTORY_DEFAULT"] = "INVENTORY_DEFAULT";
  INVENTORY_HISTORY_TYPES["RENAME_PRODUCT"] = "RENAME_PRODUCT";
  INVENTORY_HISTORY_TYPES["ALL_PRODUCTS_RESERVED"] = "ALL_PRODUCTS_RESERVED";
  INVENTORY_HISTORY_TYPES["GIVEAWAY_AUTOPAY_TOGGLE"] = "GIVEAWAY_AUTOPAY_TOGGLE";
  INVENTORY_HISTORY_TYPES["GIVEAWAY_AUTOPAY_SUCCESS"] = "GIVEAWAY_AUTOPAY_SUCCESS";
  INVENTORY_HISTORY_TYPES["GIVEAWAY_AUTOPAY_FAILED"] = "GIVEAWAY_AUTOPAY_FAILED";
  return INVENTORY_HISTORY_TYPES;
}({});
export let SendToMultipleAddressesStep = /*#__PURE__*/function (SendToMultipleAddressesStep) {
  SendToMultipleAddressesStep["uploadCSV"] = "uploadCSV";
  SendToMultipleAddressesStep["shipmentSetup"] = "shipmentSetup";
  SendToMultipleAddressesStep["billing"] = "billing";
  SendToMultipleAddressesStep["success"] = "success";
  return SendToMultipleAddressesStep;
}({});
export let UploadCSVStepScreen = /*#__PURE__*/function (UploadCSVStepScreen) {
  UploadCSVStepScreen["upload"] = "upload";
  UploadCSVStepScreen["table"] = "table";
  UploadCSVStepScreen["tableBodyWithError"] = "tableBodyWithError";
  return UploadCSVStepScreen;
}({});
export const SendToMultipleAddressesStepScreens = {
  [SendToMultipleAddressesStep.uploadCSV]: {
    [UploadCSVStepScreen.upload]: UploadCSVStepScreen.upload,
    [UploadCSVStepScreen.table]: UploadCSVStepScreen.table
  }
};
export const SendToMultipleAddressesScreenLabels = {
  [UploadCSVStepScreen.upload]: 'Upload a CSV file!',
  [UploadCSVStepScreen.table]: 'Edit your columns!',
  [UploadCSVStepScreen.tableBodyWithError]: 'Fix the errors!'
};
export const SendToMultipleAddressesLabels = {
  [SendToMultipleAddressesStep.uploadCSV]: 'CSV upload',
  [SendToMultipleAddressesStep.shipmentSetup]: 'Shipment setup',
  [SendToMultipleAddressesStep.billing]: 'Billing & Payment',
  [SendToMultipleAddressesStep.success]: 'Success'
};
export let ApprovalDistributionTypes = /*#__PURE__*/function (ApprovalDistributionTypes) {
  ApprovalDistributionTypes["add"] = "add";
  ApprovalDistributionTypes["pfi"] = "pfi";
  ApprovalDistributionTypes["sma"] = "sma";
  ApprovalDistributionTypes["transfer"] = "transfer";
  ApprovalDistributionTypes["giveaway"] = "giveaway";
  return ApprovalDistributionTypes;
}({});
export let ApprovalDistributionStatuses = /*#__PURE__*/function (ApprovalDistributionStatuses) {
  ApprovalDistributionStatuses["rejected"] = "rejected";
  ApprovalDistributionStatuses["approved"] = "approved";
  ApprovalDistributionStatuses["pending"] = "pending";
  return ApprovalDistributionStatuses;
}({});
export let INVENTORY_PURCHASE_FLOWS = /*#__PURE__*/function (INVENTORY_PURCHASE_FLOWS) {
  INVENTORY_PURCHASE_FLOWS["SOA"] = "SOA";
  INVENTORY_PURCHASE_FLOWS["SMA"] = "SMA";
  INVENTORY_PURCHASE_FLOWS["GIVEAWAY"] = "GIVEAWAY";
  INVENTORY_PURCHASE_FLOWS["STORAGE_FEE"] = "STORAGE_FEE";
  INVENTORY_PURCHASE_FLOWS["GIVEAWAY_NOTECARD"] = "GIVEAWAY_NOTECARD";
  return INVENTORY_PURCHASE_FLOWS;
}({});
export let INVENTORY_STATUS = /*#__PURE__*/function (INVENTORY_STATUS) {
  INVENTORY_STATUS["ACTIVE"] = "ACTIVE";
  INVENTORY_STATUS["FROZEN"] = "FROZEN";
  return INVENTORY_STATUS;
}({});
export let INVENTORY_STATUS_FILTER_OPTIONS = /*#__PURE__*/function (INVENTORY_STATUS_FILTER_OPTIONS) {
  INVENTORY_STATUS_FILTER_OPTIONS["ACTIVE"] = "ACTIVE";
  INVENTORY_STATUS_FILTER_OPTIONS["FROZEN"] = "FROZEN";
  INVENTORY_STATUS_FILTER_OPTIONS["ALL_STATUSES"] = "ALL_STATUSES";
  return INVENTORY_STATUS_FILTER_OPTIONS;
}({});
export let ESTIMATE_DISTRIBUTION_PRODUCT_TYPE = /*#__PURE__*/function (ESTIMATE_DISTRIBUTION_PRODUCT_TYPE) {
  ESTIMATE_DISTRIBUTION_PRODUCT_TYPE["product"] = "product";
  ESTIMATE_DISTRIBUTION_PRODUCT_TYPE["box"] = "box";
  return ESTIMATE_DISTRIBUTION_PRODUCT_TYPE;
}({});
export const ESTIMATE_DISTRIBUTION_PRODUCT_MAX_QUANTITY = 10000;
export const ESTIMATE_DISTRIBUTION_BOX_MAX_QUANTITY = 5000;
export const INVENTORY_FREEZE_AMOUNT_TO_SEND_EMAIL = 999;
export const BASE_INVENTORY_PRODUCT_COUNT = 50;
export const MONTH_SHORT_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTH_LONG_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export let STORAGE_FEE_ADJUSTMENT_TYPE = /*#__PURE__*/function (STORAGE_FEE_ADJUSTMENT_TYPE) {
  STORAGE_FEE_ADJUSTMENT_TYPE["ADJUSTMENT"] = "Adjustment";
  STORAGE_FEE_ADJUSTMENT_TYPE["DISCOUNT"] = "Discount";
  return STORAGE_FEE_ADJUSTMENT_TYPE;
}({});